/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Button, Grid2, styled, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { TagType } from '../../../data/types/tags.interface';
import { AddIcon } from '../../shared/components/AppIcons';
import SortableTableHead, { SortableTableHeadCell } from '../../shared/components/SortableTableHead';
import AddContentTypeAsset from './addContentTypeAsset';
import { capitalize } from 'lodash';
import theme from '../../../core/theme';
import usePaginatedContent from '../../shared/components/usePaginatedContent';
import { useAuthentication } from '../../auth/services/auth.provider';

const useStyles = makeStyles({
  header: {
    fontSize: '36px',
  },
  add: {
    height: '36px',
    backgroundColor: '#F67570 !important',
    color: '#fff !important',
    '& g path': {
      fill: '#ffffff !important',
    },
    '& .MuiButton-startIcon': {
      margin: '0px !important',
    },
  },
  table: {
    '& .MuiTableHead-root': {
      backgroundColor: '#30343F',
      color: '#fff !important',
      fontSize: '17px',
      '& .MuiTableCell-root': {
        paddingLeft: '0',
      },
      '& .MuiTableSortLabel-root.Mui-active': {
        color: '#fff !important',
        '&:hover': {
          color: '#fff !important',
        },
      },
      '& .MuiTableSortLabel-icon': {
        color: '#fff !important',
      },
    },
  },
  hover: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
});

const StyledTableCell: any = styled(TableCell)(() => ({
  paddingTop: '12px',
  paddingBottom: '12px',
  borderBottom: `1px solid ${theme.palette.chipBg.main}`,
}));

const ContentTypeAsset: React.FC = () => {
  const classes = useStyles();
  const { currentUser } = useAuthentication();
  const isAdminOrCreativeEditor = ['admin', 'creative_editor'].includes(currentUser?.role.name || '');
  const [columnHeader, setColumnHeader] = useState<SortableTableHeadCell<any>[]>([]);
  const [openAddModal, setOpenAddModal] = useState(false);
  const { contentTypes } = usePaginatedContent();

  useEffect(() => {
    setColumnHeader([
      { id: 'id', label: 'Id', numeric: true, sortable: false },
      { id: 'contentType', label: 'Content type', numeric: false, sortable: false },
    ]);
  }, []);

  return (
    <Grid2 container direction="column">
      <Grid2 container justifyContent="space-between" alignItems="center" height="84px">
        <Grid2 container pl="20px">
          <span className={classes.header}>Asset, Content Types</span>
        </Grid2>
        {isAdminOrCreativeEditor && <Grid2 container mr="10px">
          <Button
            size="small"
            className={classes.add}
            startIcon={<AddIcon viewBox="0 0 42 42" style={{ fontSize: '35px' }} />}
            onClick={() => setOpenAddModal(true)}
          >
            <span style={{ fontSize: 'h5', textTransform: 'none', marginRight: '10px' }}>Add Asset Type</span>
          </Button>
        </Grid2>}
      </Grid2>

      <TableContainer className={classes.table} sx={{ overflow: 'hidden' }}>
        <Table sx={{ tableLayout: 'fixed', width: '100%' }}>
          <SortableTableHead
            onRequestSort={() => null}
            order={'asc'}
            orderBy={''}
            headCells={columnHeader}
            headerVariant="subtitle2"
          />
          {contentTypes?.length > 0 ? (
            <TableBody sx={{ color: '#303340' }}>
              {contentTypes.map((type: TagType) => (
                <>
                  <TableRow key={type.id}>
                    <StyledTableCell component="td" width="20%" role="button" className={classes.hover}>
                      <div>{type?.id}</div>
                    </StyledTableCell>
                    <StyledTableCell component="td" role="button" className={classes.hover}>
                      <div>{capitalize(type.name)}</div>
                    </StyledTableCell>
                  </TableRow>
                </>
              ))}
            </TableBody>
          ) : (
            <TableBody sx={{ color: '#303340' }}>
              <TableRow>
                <TableCell colSpan={8} align="center">
                  You have not yet created any content type.
                </TableCell>
              </TableRow>
            </TableBody>
          )}
        </Table>

        {openAddModal && <AddContentTypeAsset setOpenPopup={setOpenAddModal} contentTypes={contentTypes} />}
      </TableContainer>
    </Grid2>
  );
};

export default ContentTypeAsset;
